/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import { client, withUnwrap } from '../.kubb/client'
import type { PaymentsProcessOptions, PaymentsProcessResponses } from '../models/PaymentsProcess'
import {
  paymentsProcessResponseSchema,
  paymentsProcessErrorSchema,
  paymentsProcessBodySchema,
} from '../schemas/paymentsProcessSchema'

/**
 * @summary The bank return: validates the payment with the bank and settles the order once. A repeated call for an
 * order already paid answers the same result without settling again. On success the client switches into
 * `switchToOrgId` with `auth/switch`. Settles registration orders so far. Logged.
 * {@link /api/v4/payments/process}
 */
export function paymentsProcess<ThrowOnError extends boolean = true>(
  options: Options<PaymentsProcessOptions, ThrowOnError>
): Unwrappable<RequestResult<PaymentsProcessResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/api/v4/payments/process',
      security: [{ type: 'http', scheme: 'bearer' }],
      validator: {
        request: paymentsProcessBodySchema,
        response: paymentsProcessResponseSchema,
        error: paymentsProcessErrorSchema,
      },
      contentType: { request: 'application/json-patch+json' },
      ...config,
    }) as Promise<RequestResult<PaymentsProcessResponses, ThrowOnError>>
  )
}
